import { Component, OnInit } from "@angular/core";
import { LogService } from "ng/src/app/logs/log.service";
import { SelectorItem } from "ng/src/app/shared/item-selectors/item-selector.model";
import { Inplace } from "primeng/inplace";
import { DataType, LogConfig } from "ng/src/app/logs/log.model";
import { NoteControlOptions, NoteControlType } from "ng/src/app/notes/note-controller/note-controller-options.model";

@Component({
	selector: 'lb-enter-note-selector',
	template: `
        <ng-container *ngIf="canEdit">
            <p-inplace #editor (onDeactivate)="newValue = current">
                <ng-template pTemplate="display">
                    <button pButton class="display-button p-button-link" [label]="getLabel(current)"
                            (click)="editor.activate($event)"></button>
                </ng-template>
                <ng-template pTemplate="content">
                    <p-dropdown [(ngModel)]="newValue" [options]="options" optionLabel="display"
                                optionValue="value"></p-dropdown>
                    <div class="p-mt-1">
                        <button pButton icon="pi pi-check" (click)="save(editor)"></button>
                        <button pButton class="p-button-secondary p-ml-1" icon="pi pi-times"
                                (click)="editor.deactivate($event)"></button>
                    </div>
                </ng-template>
            </p-inplace>
        </ng-container>
        <span *ngIf="!canEdit">{{getLabel(current)}}</span>
	`,
	styles: [
		':host .display-button, :host ::ng-deep .p-inplace-display { padding: 0 }',
		':host ::ng-deep .p-dropdown { width: 100%}'
	]
})
export class EnterNoteSelectorComponent implements OnInit {
	
	readonly options: SelectorItem<NoteControlType | null>[] = [
		SelectorItem.from(null, this.getLabel),
		SelectorItem.from('BAR', this.getLabel),
		SelectorItem.from('DIALOG', this.getLabel),
		SelectorItem.from('FULLSCREEN', this.getLabel),
		SelectorItem.from('ENTER_NOTES', this.getLabel)
	];
	
	current: NoteControlType | null = this.options[0]?.value ?? null;
	newValue: NoteControlType | null = this.options[0]?.value ?? null;
	
	config?: LogConfig;
	
	get canEdit() {
		return LogService.selectedLog?.role === 'ADMIN';
	}
	
	constructor(
		private logService: LogService
	) {}
	
	ngOnInit(): void {
		this.logService.getLogConfigValues('defaultNoteEntry', LogService.selectedLog!.id).subscribe(res => {
			this.config = res[0];
			const option = NoteControlOptions.validateOption(this.config?.value as any);
			this.current = this.newValue = this.options.find(o => o.value === option)?.value ?? null;
		});
	}
	
	save(editor: Inplace) {
		this.logService.saveConfigValue({
			key: 'defaultNoteEntry',
			hierarchy: 'logbook.webui.config',
			value: this.newValue ?? 'null',
			logId: LogService.selectedLog!.id
		}, DataType.SHORT_TEXT)
			.subscribe(() => {
				this.current = this.newValue;
				editor.deactivate();
			});
	}
	
	getLabel(value: NoteControlType | null) {
		switch (value) {
			case null:
				return 'Default';
			case 'BAR':
				return 'Bottom Bar';
			case 'DIALOG':
				return 'Popup';
			case 'ENTER_NOTES':
				return 'Enter Notes Page';
			case 'FULLSCREEN':
				return 'Fullscreen Page'
		}
	}
}